(function() {
  'use strict';

  let headerContainer = null;
  let ticking = false;

  function findElements() {
    // Verifica se está no template index
    if (!document.body.classList.contains('template-index')) {
      return false;
    }
    
    // Procura pelo data attribute (sempre presente se a opção existe)
    headerContainer = document.querySelector('.header-container[data-transparent-header="true"]');
    
    if (!headerContainer) {
      // Fallback: procura pela classe
      headerContainer = document.querySelector('.header-container.header-transparent-enabled');
    }
    
    return !!headerContainer;
  }

  function updateHeaderState() {
    if (!headerContainer) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const wasTransparent = headerContainer.classList.contains('transparent');
    
    if (scrollTop > 40) {
      // Scrollou para baixo além de 40px - remove classe transparent
      if (wasTransparent) {
        headerContainer.classList.remove('transparent');
      }
    } else {
      // No topo ou scroll menor que 40px - adiciona classe transparent
      if (!wasTransparent) {
        headerContainer.classList.add('transparent');
      }
    }
  }

  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateHeaderState();
        ticking = false;
      });
      ticking = true;
    }
  }

  function init() {
    // Tenta encontrar os elementos
    if (!findElements()) {
      return false;
    }

    // Inicializa o estado baseado na posição inicial do scroll
    updateHeaderState();

    // Adiciona listener de scroll
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    console.log('Transparent Header: Inicializado com sucesso', {
      headerContainer: !!headerContainer
    });
    return true;
  }

  // Função para tentar inicializar com retry
  function tryInit() {
    if (init()) {
      return; // Sucesso!
    }
    
    // Se não encontrou, tenta novamente após um delay
    setTimeout(function() {
      if (!headerContainer) {
        if (init()) {
          return;
        }
        console.log('Transparent Header: Tentando novamente...');
      }
    }, 500);
  }

  // Inicializa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    // DOM já está pronto, mas pode precisar esperar o Shopify renderizar
    setTimeout(tryInit, 100);
  }

  // Também tenta no load como fallback
  window.addEventListener('load', function() {
    if (!headerContainer) {
      setTimeout(tryInit, 200);
    }
  });
})();

